import { PAGES } from '@ats/constants';
import { ATTENDEE_TYPE } from '@constants/attendee';
import { useLocation } from 'react-router';

export const useGetPath = () => {
  const location = useLocation();
  const pathRoot = location.pathname.split('/')[1];

  switch (pathRoot) {
    case 'interviewer':
      return {
        attendeeType: ATTENDEE_TYPE.INTERVIEWER,
        rootPath: PAGES.VIDEO_INTERVIEW.INTERVIEWER,
      };

    case 'interviewee':
      return {
        attendeeType: ATTENDEE_TYPE.INTERVIEWEE,
        rootPath: PAGES.VIDEO_INTERVIEW.INTERVIEWEE,
      };

    default:
      return {
        attendeeType: ATTENDEE_TYPE.INTERVIEWEE_SECURE,
        rootPath: PAGES.VIDEO_INTERVIEW.INTERVIEWEE_SECURE,
      };
  }
};
